var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"a-loading-primary"},[_c('img',{attrs:{"alt":"loading","src":require("@/assets/loading/a-loading-primary.svg")}}),_c('p',[_vm._v("Cargando Datos...")])])
}]

export { render, staticRenderFns }